import React from 'react';
import { NavLink } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import styled, { useTheme } from 'packages/theming';
import { Box, Text, constants } from '@match/react-component-library';
import { useCategories, useSiteData } from 'modules/hooks';
import { FAQ_CONSTANTS } from 'modules/constants';

const { CONTACT_US_ID } = FAQ_CONSTANTS;

const { SEMANTIC_COLOR_NAME, SPACE, TYPOGRAPHY } = constants;

interface LeftNavProps {
  activeCategoryId?: number | string;
}

const LeftNav: React.FunctionComponent<LeftNavProps> = ({ activeCategoryId }) => {
  const { categories } = useCategories();
  const intl = useIntl();
  const theme = useTheme();
  const { siteDataLoaded } = useSiteData();

  const leftNavItems = React.useMemo(() => {
    return [
      {
        id: '',
        name: intl.formatMessage(messages.mostPopular),
      },
      ...categories,
    ];
  }, [categories, intl.formatMessage]);

  if (!siteDataLoaded) {
    return <Box width={202} />;
  }

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      {leftNavItems.map(({ id, name }) => (
        <StyledLink
          activeStyle={{ background: theme.palette.core1_100 }}
          exact
          to={`/${id}`}
          isActive={() => (activeCategoryId || '') === id}
          key={id}
        >
          <Box center padding={SPACE.LARGE} height={68} textAlign="center">
            <Text color={SEMANTIC_COLOR_NAME.LIGHT} bold typography={TYPOGRAPHY.STANDARD_BODY}>
              {name}
            </Text>
          </Box>
        </StyledLink>
      ))}
      <StyledLink
        activeStyle={{ background: theme.palette.core1_100 }}
        exact
        to={`/${CONTACT_US_ID}`}
        isActive={() => (activeCategoryId || '') === CONTACT_US_ID}
      >
        <Box center padding={SPACE.LARGE} height={68} textAlign="center">
          <Text color={SEMANTIC_COLOR_NAME.LIGHT} bold typography={TYPOGRAPHY.STANDARD_BODY}>
            {intl.formatMessage(messages.contactUs)}
          </Text>
        </Box>
      </StyledLink>
    </Box>
  );
};

export default LeftNav;

const StyledLink = styled(NavLink)(({ theme }) => {
  const { palette, space } = theme;
  return {
    background: palette.core1_50,
    height: '68px',
    width: '202px',
    marginBottom: space.medium,
    '&:hover': {
      textDecoration: 'none',
    },
  };
});

const messages = defineMessages({
  mostPopular: {
    id: 'src/modules/components/LeftNav/LeftNav:mostPopular',
    description: 'most popular category text',
    defaultMessage: 'Most Popular',
  },
  contactUs: {
    id: 'src/modules/components/LeftNav/LeftNav:contactUs',
    description: 'contact us category text',
    defaultMessage: 'Contact Us',
  },
});
